import React, { Component } from 'react';
import { formatPricing } from 'src/helpers';

class AddToCardPreview extends Component<ComposedProps, State> {
  render() {
    const { numberOfProduct, selectedProducts, tenantApp, buttonText, buttonStyle, widget } =
      this.props;
    let total = 0;
    let totalAfterDiscount = 0;
    let numberOfSelectedProducts = 0;
    const products = Object.values(selectedProducts);
    for (let i = 0; i < numberOfProduct; i++) {
      total += products[i] && products[i].selected && products[i].price ? +products[i].price : 0;
      numberOfSelectedProducts += products[i] && products[i].selected ? 1 : 0;
    }

    totalAfterDiscount = total;
    if (numberOfSelectedProducts === numberOfProduct) {
      // Calculate discount
      let { discountType, discountValue } = widget;
      discountValue = Number(discountValue);
      if (discountType === 'percentage') {
        totalAfterDiscount = total - (total * discountValue) / 100;
      } else if (discountType === 'amount') {
        totalAfterDiscount = total - discountValue;
      }

      totalAfterDiscount = totalAfterDiscount < 0 ? 0 : totalAfterDiscount;
    }

    return (
      <React.Fragment>
        <div className="cart">
          <div className="cart-wrapper">
            <div className="cart-inner">
              <div className="total">
                Total price:{' '}
                {totalAfterDiscount !== total ? (
                  <span>
                    <span>
                      {formatPricing(
                        totalAfterDiscount,
                        tenantApp?.externalInfo?.money_in_emails_format
                      )}
                    </span>{' '}
                    <span style={{ textDecoration: 'line-through', color: '#7A7A7A' }}>
                      {formatPricing(total, tenantApp?.externalInfo?.money_in_emails_format)}
                    </span>
                  </span>
                ) : (
                  <span>
                    {formatPricing(total, tenantApp?.externalInfo?.money_in_emails_format)}
                  </span>
                )}
              </div>
              <button className="add-to-cart" style={{ ...buttonStyle, width: 'auto' }}>
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default AddToCardPreview;
